@if (lib === 'fn') {
  <fa-icon [icon]="icon" [style]="style" [size]="size" [animation]="animation" [color]="color" [align]="align"
  ></fa-icon>
}
